import { RemainOnBoardUnitsApi, RestowResponseDto } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'
import { Event, IEvent, IQueryHandler, IQueryMessage } from '@tom-ui/utils'

export class GetRestowsQuery implements IQueryMessage {
  static type = 'GetRestowsQueryHandler'
  type = GetRestowsQuery.type

  constructor(public vesselVisitId: number) {}

  getKey = () => {
    return JSON.stringify(this)
  }
}

const httpClient = createApiClient(RemainOnBoardUnitsApi)

export const GetRestowsQueryHandler: IQueryHandler<
  GetRestowsQuery,
  IEvent<RestowResponseDto[]>
> = async query => {
  const { data } = await httpClient.getRestowsByVesselVisit(query.vesselVisitId)

  return new Event(GetRestowsQuery.type, data)
}
